<template>
  <div class="container">
    <div class="about">
      <h1>About</h1>
      <h2>Made By</h2>
      <p><a href="https://www.helm108.com/" target="_blank">James Fidler</a> {{ copyright }}</p>
      <h2>Submit a Bug Report or a Feature Request</h2>
      <p><a href="https://gitlab.com/terrarum/multi-panel-image-zoom-generator/issues/">https://gitlab.com/terrarum/multi-panel-image-zoom-generator/issues/</a></p>
      <h2>Made With</h2>
      <p><a href="https://vuejs.org/" target="_blank">Vue.js</a></p>
      <p><a href="http://www.netlify.com/" target="_blank">Netlify</a></p>
      <h2>Credit</h2>
      <p>
        <a href="https://unsplash.com/photos/U6nlG0Y5sfs" target="_blank">Pink Wall Full of Dogs</a> by <a href="https://unsplash.com/@hannah15198" target="_blank">Hannah Lim</a> from
        <a href="https://unsplash.com" target="_blank">Unsplash</a>
      </p>
      <p>
        <a href="https://unsplash.com/photos/9KpQrPEy8P8" target="_blank">Short-fur orange and black cat</a> by <a href="https://unsplash.com/@caleb_woods" target="_blank">Caleb Woods</a> from
        <a href="https://unsplash.com" target="_blank">Unsplash</a>
      </p>
      <p>
        <a href="https://thenounproject.com/sommerladboy/collection/mouse/?i=1056957" target="_blank">Mouse Left Click</a> by <a href="https://thenounproject.com/sommerladboy/" target="_blank">Benjamin Sommerlad</a> from the <a href="https://thenounproject.com/" target="_blank">Noun Project</a>
      </p>
      <p>
        <a href="https://thenounproject.com/unlimicon/collection/direct/?i=929852" target="_blank">Arrow Right</a> by <a href="https://thenounproject.com/unlimicon/" target="_blank">unlimicon</a> from the <a href="https://thenounproject.com/" target="_blank">Noun Project</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  computed: {
    copyright() {
      return `© ${new Date().getFullYear()}`;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/variables';

  .about {
    padding: $spacing;
  }
</style>
